import classnames from 'classnames';

import INavigationCategory from '../../../../../../interfaces/navigation-category';
import INavigationLink from '../../../../../../interfaces/navigation-link';
import OCButton from '../../../../../button';
import Title from '../../../../../title';
import Icon from '~/components/icon';
import Link from '../../../../../link';
import { Header } from '../../../../../title/title';

import styles from './all-sports-menu.module.css';
import { useServicesContext } from '~/providers/services-context.tsx';

interface IProps {
  allSports: INavigationCategory[];
  featuredSports: INavigationLink[];
  featuredPages: INavigationLink[];
  closeMenuFn: () => void;
}

const AllSportsMenu: React.FC<IProps> = ({
  allSports,
  featuredSports,
  featuredPages,
  closeMenuFn
}) => {
  const { labelActions } = useServicesContext();

  const renderSidebar = () => {
    return (
      <div data-testid="sidebar" className={styles.sidebar}>
				{featuredSports?.length &&
        <div data-testid="featured-sports" className={styles.sports}>
						{featuredSports.map((sport) =>
          <Link
            key={sport.text}
            to={sport.url}
            className={classnames(
              styles.item,
              sport.isSelected ? styles.selected : ''
            )}>

								{sport.text}
							</Link>
          )}
					</div>
        }

				<div data-testId="pages" className={styles.picksAndInsights}>
					{featuredPages.map((page) =>
          <Link
            key={page.text}
            to={page.url}
            className={classnames(
              styles.item,
              page.isSelected ? styles.selected : ''
            )}>

							{page.text}
						</Link>
          )}
				</div>
			</div>);

  };

  const renderAllSports = () => {
    if (!allSports?.length) {
      return null;
    }

    return (
      <div data-testid="all-sports" className={styles.allSports}>
				{allSports.map((sport) => {
          if (!sport?.subCategories?.length) {
            return null;
          }

          let sportIcon;
          if (sport.icon) {
            const [icon, dimension = '14'] = sport.icon.split(',');
            sportIcon =
            <Icon
              icon={icon}
              className={styles.sportIcon}
              height={parseInt(dimension, 10)}
              width={parseInt(dimension, 10)} />;


          }

          return (
            <div data-testid="sport" key={sport.text} className={styles.sport}>
							<Link
                title={sport.text}
                to={sport.url}
                className={styles.nameWithIcon}>

								{sport.icon && sportIcon}
								{sport.text}
							</Link>

							<div
                data-testid="sub-categories"
                className={styles.subCategories}>

								{sport.subCategories.map((sub) =>
                <Link key={sub.text} to={sub.url}>
										<div className={styles.subCategory}>{sub.text}</div>
									</Link>
                )}
							</div>
						</div>);

        })}
			</div>);

  };

  return (
    <div className={styles.allSportsMenu}>
			<div className={styles.header}>
				<Title
          tag={Header.SPAN}
          title={labelActions.get('RESPONSIVE_SPORTS_ODDS')}
          noPadding
          className={styles.title}
          testId="all-sports-heading" />


				<OCButton onClick={closeMenuFn} className={styles.closeBtn}>
					<Icon icon="Close" className={styles.closeIcon} />
				</OCButton>
			</div>

			<div className={styles.body}>
				{renderSidebar()}
				{renderAllSports()}
			</div>
		</div>);

};

export default AllSportsMenu;